import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';

export const EmbedContainer = styled.div`
    display: flex;
    ${mediaMaxWidth.medium`
    gap: 16px;
    flex-wrap: wrap;
    `}
`;

export const EmbedRow = styled.div`
    flex: ${({ flex }) => flex || 1};
    min-height: 600px;

    ${mediaMaxWidth.medium`
        flex-basis: 100%;
    `}
`;
